import { render, staticRenderFns } from "./leaveEditForm.vue?vue&type=template&id=5c6f1908&scoped=true&lang=en&"
import script from "./leaveEditForm.vue?vue&type=script&lang=js&"
export * from "./leaveEditForm.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/listing.css?vue&type=style&index=0&id=5c6f1908&scoped=true&lang=css&"
import style1 from "../../../assets/css/detail-page.css?vue&type=style&index=1&id=5c6f1908&scoped=true&lang=css&"
import style2 from "./leaveEditForm.vue?vue&type=style&index=2&id=5c6f1908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f1908",
  null
  
)

export default component.exports